import './login_component.scss'
import { Controller } from 'stimulus'
import isEmail from 'validator/lib/isEmail'

export default class extends Controller {
  static targets = ['email', 'button', 'form']
  static values = { state: String }
  static classes = ['hide', 'disabled']

  activate = (): void => {
    this.buttonTargets.forEach(button => {
      button.classList.remove(this.hideClass)
      button.classList.remove(this.disabledClass)
    })
  }

  deactivate = (target: HTMLElement): void => {
    target.classList.add(this.disabledClass)
    this.buttonTargets.forEach(button => {
      if (target === button) return
      button.classList.add(this.hideClass)
    })
    setTimeout(() => {
      this.activate()
    }, 4800)
  }

  submit = (event: object): void => {
    event.preventDefault()

    if (this.validEmail) {
      this.deactivate(event.target)
      this.formTarget.submit()
    } else {
      this.inputController.shake()
      this.inputController.inputTarget.focus()
    }
  }

  get inputController (): HTMLElement {
    return this.application.getControllerForElementAndIdentifier(this.emailTarget.children[0], 'text-input')
  }

  get email (): string {
    return this.inputController.inputTarget.value
  }

  get validEmail (): boolean {
    return isEmail(this.email) === true
  }

  get stateQueryString (): string {
    return this.stateValue
  }
}
